export const SUBMIT_ACCOUNT_TO_NEWSLETTER = 'SUBMIT_ACCOUNT_TO_NEWSLETTER ';
